import UserActivity from "../../components/users/user-activity.component"
import UserDetailsHome from "../../components/users/user-details-home.component"
import UserEvents from "../../components/users/user-events.component"
import UserUpadate from "../../components/users/user-update.component"
import { ERoles } from "../../constants/enum"
import { ISubPageRoute } from "../../interfaces/pages"

const userDetailsRoutes: ISubPageRoute[] = [
    {
        path: "/admin/users/:id",
        name: "Details",
        component: UserDetailsHome,
        permission: [ERoles.SUPERADMIN, ERoles.OPERATOR, ERoles.REGIONADMIN, ERoles.SUPPLIER],
    },
    {
        path: "/admin/users/:id/update",
        name: "Edit",
        component: UserUpadate,
        permission: [ERoles.SUPERADMIN],
    },
    {
        path: "/admin/users/:id/events",
        name: "Events",
        component: UserEvents,
        permission: [ERoles.SUPERADMIN],
    },
    {
        path: "/admin/users/:id/activity",
        name: "Activity",
        component: UserActivity,
        permission: [ERoles.SUPERADMIN],
    },
]

export default userDetailsRoutes
